// import React from 'react';
// import ReusableTabs from '../../../pages/ReusableTabs';
// import UploadSection from './Sections/UploadSection';
// import LibrarySection from './Sections/LibrarySection';
// import AuditSection from './Sections/AuditSection';

// const QualityPanel = () => {
//   const tabs = [
//     { label: 'UPLOAD', component: <UploadSection /> },
//     { label: 'LIBRARY', component: <LibrarySection /> },
//     { label: 'AUDITS', component: <AuditSection /> },
//   ];

//   return (
//     <div>
//       <ReusableTabs
//         tabs={tabs}
//         defaultTab={0}
//         panelStyles={{ padding: '16px' }}
//       />
//     </div>
//   );
// };

// export default QualityPanel;

import React, { useState, useEffect } from 'react';
import ReusableTabs from '../../../pages/ReusableTabs';
import UploadSection from './Sections/UploadSection';
import LibrarySection from './Sections/LibrarySection';
import AuditSection from './Sections/AuditSection';

const QualityPanel = () => {
  const [canEditQuality, setCanEditQuality] = useState(false);

  useEffect(() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    if (storedRoles) {
      let roles = [];
      try {
        const parsed = JSON.parse(storedRoles);
        if (Array.isArray(parsed)) roles = parsed;
      } catch {
        roles = storedRoles.split(",").map(r => r.trim());
      }
      setCanEditQuality(roles.includes("SD_Quality_Edit"));
    }
  }, []);

  const tabs = [
    ...(canEditQuality
      ? [{ label: 'UPLOAD', component: <UploadSection /> }]
      : []
    ),
    { label: 'LIBRARY', component: <LibrarySection /> },
    { label: 'AUDITS', component: <AuditSection /> },
  ];

  return (
    <div>
      <ReusableTabs
        tabs={tabs}
        defaultTab={0}
        panelStyles={{ padding: '16px' }}
      />
    </div>
  );
};

export default QualityPanel;